import React from "react"
import { useDispatch } from "react-redux"
import { Container, Alert, ListGroup, Card, CardBody } from "reactstrap"
import MemberItem from "../MemberItem"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { setCurrentPage } from "../../../store/reducers/navigation"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faExchangeAlt,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons"
import StellarLoader from "../../layout/StellarLoader"
import OfflineBalanceBanner from "../../layout/OfflineBalanceBanner"
import styles from "./style.module.css"

function MemberList(props) {
  const { i18n } = useLingui()
  const id = props.id
  const { filterMembers } = props
  const dispatch = useDispatch()
  const [visibleItems, setVisibleItems] = React.useState(10)


  const loadMore = () => {
    setVisibleItems((prev) => prev + 10)
  }

  const goToTransactionStatuses = () => {
    dispatch(setCurrentPage("group-meetingTransactions"))
  }

  const [hasFailedTransactions, setHasFailedTransactions] = React.useState(false)
  React.useEffect(() => {
    if (!props.ongoingMeeting) {
      return
    }
    setHasFailedTransactions(
      props.meetingTransactions.filter(
        (item) => item.status?.toLocaleLowerCase() === "failed",
      ).length > 0,
    )
  }, [props.meetingTransactions])

  if (props.isLoading) {
    return <StellarLoader />
  }

  if (!props.members.length) {
    return (
      <Container>
        <Alert
          color="warning"
          className={
            i18n.locale === "ar" ? "text-right" : "text-left"
          }
        >
          <span className={styles.warningText}>
            <Trans id="no.members.in.group">No members in this group</Trans>
          </span>
        </Alert>
      </Container>
    )
  }

  return (
    <div className={styles.container}>
      <OfflineBalanceBanner />
      <Container className={styles.listContainer}>
        <div>
          <br />
          <h4 className={styles.header}>
            <Trans id="member.list.overview">Members Overview</Trans>
          </h4>
        </div>
        <Card>
          <CardBody>
            <ListGroup flush>
              {filterMembers.slice(0, visibleItems).map((member) => {
                return (
                  member && (
                    <MemberItem
                      isFailed={member.syncStatus === "error"}
                      isInProgress={member.syncStatus === "processing"}
                      isPending={member.syncStatus === "pending"}
                      members={props.members}
                      key={member.pubkey}
                      cacheKey={member.cacheId}
                      member_details={member}
                      vsla_id={id}
                    />
                  )
                )
              })}
            </ListGroup>
            {filterMembers.length === 0 && props.members.length > 0 ? (
              <span
                name="search-results-not-found"
                className={styles.noResults}
              >
                <Trans id="Not found">Not found</Trans>
              </span>
            ) : (
              <></>
            )}
            {visibleItems < filterMembers.length && (
              <div className="d-flex justify-content-center mt-3">
                <button className="btn btn-light" onClick={loadMore}>
                  Load More
                </button>
              </div>
            )}
          </CardBody>
        </Card>
        {props.ongoingMeeting && (
          <button onClick={goToTransactionStatuses} className={styles.fab}>
            <FontAwesomeIcon
              icon={faExchangeAlt}
              style={{ marginRight: "8px" }}
            />
            <Trans id="Transaction Status"></Trans>
            {hasFailedTransactions && (
              <FontAwesomeIcon
                className={styles.errorIcon}
                icon={faExclamationCircle}
              />
            )}
          </button>
        )}
      </Container>
    </div>
  )
}

MemberList.propTypes = {
  id: PropTypes.string,
  isConnected: PropTypes.bool,
  ongoingMeeting: PropTypes.object,
  meetingTransactions: PropTypes.array,
  filterMembers: PropTypes.array,
}

const mapStateToProps = (state) => ({
  isConnected: state.isConnected,
  ongoingMeeting: state.meeting?.ongoing,
  meetingTransactions: state.meetingTransactions,
  members: state.loadedvslaMembers,
  isLoading: state.vlsaMembersLoadingStarted,
})
export default connect(mapStateToProps, null)(MemberList)
